import VNBDto from '../Verteilnetzbetreiber/VNBDto'

export default class GPDto {

  constructor(json) {
    if (json) {
      this.json = json

      this.id = json.id;
      this.vnbExtId = json.verteilnetzbetreiber.extId
      this.vnbName = json.verteilnetzbetreiber.name
      this.extId = json.extId;
      this.uid = json.uid;
      this.name = json.name;
      this.email = json.email;
      this.telefon = json.telefon;
      this.strasse = json.strasse;
      this.zusatz = json.zusatz;
      this.plz = json.plz;
      this.ort = json.ort;
      this.kanton = json.kanton;
      this.verantwortlichePersonName = json.verantwortlichePersonName;
      this.verantwortlichePersonVorname = json.verantwortlichePersonVorname;
      this.ostralPersonTelefon = json.ostralPersonTelefon;
      this.sprache = json.sprache;
      this.elektronischeVerfuegung = json.elektronischeVerfuegung;
    } else {
      this.json = {}
      this.verteilnetzbetreiber = new VNBDto()
    }
  }

  get adresse() {
    return [
      [this.plz, this.ort].filter(v => v).join(' '),
      [this.strasse, this.zusatz].filter(v => v).join(' ')
    ].filter(v => v).join(', ')
  }

  get vnb() {
    return this.vnbName
  }

  get verantwortlichePerson() {
    return [
      this.verantwortlichePersonName,
      this.verantwortlichePersonVorname,
    ].filter(v => v).join(' ')
  }
}
